export const getDateFromDateTime = (dateObject: Date): string => {
  return `${dateObject.getFullYear().toString().padStart(4, '0')}-${(dateObject.getMonth() + 1).toString().padStart(2, '0')}-${dateObject.getDate().toString().padStart(2, '0')}`;
};
